import script from "./MediaLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&setup=true&lang=js"

import "./MediaLibrary.vue?vue&type=style&index=0&id=31371a2a&lang=scss"

const __exports__ = script;

export default __exports__